<script setup>
import { computed } from "vue";
import RollingDigit from "./RollingDigit.vue";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  fontSize: {
    type: [Number, String],
    default: null,
  },
  typography: {
    type: String,
    default: null,
    validator: (value) =>
      !value || ["h1", "h2", "h3", "h4", "p1", "p2"].includes(value),
  },
  duration: {
    type: Number,
    default: 0.5,
  },
  prefix: {
    type: String,
    default: "",
  },
  suffix: {
    type: String,
    default: "",
  },
});

// 숫자를 포맷팅된 문자열 배열로 분리
const splitValue = computed(() => {
  const formatted = new Intl.NumberFormat("ko-KR").format(props.value);
  return formatted.split("");
});
</script>

<template>
  <div class="rolling-counter__container">
    <template v-if="prefix"
      ><span>{{ prefix }}</span></template
    >
    <span
      class="rolling-counter"
      :class="{ [`rolling-counter--${typography}`]: typography }"
      :data-typography="typography || undefined"
    >
      <template
        v-for="(char, index) in splitValue"
        :key="`${value}-${index}-${char}`"
      >
        <RollingDigit
          v-if="/^[0-9]$/.test(char)"
          :key="`digit-${value}-${index}-${char}`"
          :digit="parseInt(char)"
          :height="fontSize"
          :typography="typography"
          :duration="duration"
        />
        <span v-else class="rolling-counter__char">{{ char }}</span>
      </template>
    </span>
    <template v-if="suffix"
      ><span>{{ suffix }}</span></template
    >
  </div>
</template>

<style scoped>

</style>
